module.exports = __webpack_public_path__ + "img/ideen_Arrow_grey.0fa5ba3b.png";